import React from 'react'
import {BsToggleOn, BsToggle2Off} from 'react-icons/bs';
import VisDiv from './frontend_components/VisDiv';
import Divider from './frontend_components/Divider';

/**
 * A toggle button component that displays a label and description.
 * The button changes icon based on the value prop.
 * 
 * @param {boolean} value - Whether the button is true or false.
 * @param {function} onClick - The function to call when the button is clicked.
 * @param {string} label - The label to display next to the button.
 * @param {string} description - The description to display below the button.
 * @param {boolean} descriptionDivider - Whether to display a divider below the description. Defaults to true.
 */
const TrueFalseToggle = ({value, onClick, label, description, descriptionDivider=true}) => {
    const icon = value
    ? <BsToggleOn className="toggle-icon-true" />
    : <BsToggle2Off className="toggle-icon-false"/>
  return (
    <div>
      <div style={{display:"flex", alignItems:"center"}}>
        <VisDiv style={{marginRight:"5px"}} rules={[label]}>
            <h4>{label}:</h4>
          </VisDiv>
          <button type="button" onClick={onClick} className="toggle-button">
              {icon}
          </button>
      </div>
      <VisDiv rules={[description]}>    
        <p>{description}</p>
        <VisDiv rules={[descriptionDivider]}>
          <Divider/>
        </VisDiv>
       
      </VisDiv>
      <VisDiv rules={[descriptionDivider, !description]}>
          <Divider/>
        </VisDiv>
    </div>
  )
}

export default TrueFalseToggle
